export class KafkaInferSchemaRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "bootstrapServers",
            "baseName": "bootstrapServers",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "security",
            "baseName": "security",
            "type": "KafkaSecurityConfig",
            "format": ""
        },
        {
            "name": "topic",
            "baseName": "topic",
            "type": "string",
            "format": ""
        },
        {
            "name": "sampleCount",
            "baseName": "sampleCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "format",
            "baseName": "format",
            "type": "KafkaMessageFormat",
            "format": ""
        },
        {
            "name": "fieldOverrides",
            "baseName": "fieldOverrides",
            "type": "Array<FieldOverride>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaInferSchemaRequest.attributeTypeMap;
    }
    constructor() {
    }
}
